var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sac-left-side-bar"},[_c('div',{staticClass:"sac-lsb-options"},[_c('h3',{staticClass:"sac-title"},[_vm._v("Settings")]),_vm._l((_vm.options),function(op,index){return _c('div',{staticClass:"sac-lsb-section"},[_c('span',{staticClass:"sac-label"},[_vm._v(_vm._s(op.label))]),_vm._l((op.subOptions),function(option,idx){return _c('div',{key:idx,class:[
          'sac-lsb-option',
          _vm.activeTab === option.value ? 'active' : '',
        ],on:{"click":function($event){return _vm.change(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])})],2)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }